import { Keyboard } from 'lucide-react';
import { TaskItemCard, fillCopy } from '@/features/contribution-kit';
import { cn } from '@/lib/utils';
import type { LabelImagesCopy } from '../label-images-copy';

/**
 * The chosen character, big, in a slot that opens the on-screen keyboard
 * (the only way to type it, as before), plus a keyboard toggle in the corner.
 */
export function CharacterSlot({
  copy,
  value,
  keyboardOpen,
  onToggleKeyboard,
}: {
  copy: LabelImagesCopy;
  value: string;
  keyboardOpen: boolean;
  onToggleKeyboard: () => void;
}) {
  return (
    <TaskItemCard
      label={copy.answerLabel}
      corner={
        <button
          type="button"
          onClick={onToggleKeyboard}
          aria-pressed={keyboardOpen}
          className={cn(
            'inline-flex h-9 items-center gap-1.5 rounded-full border px-3 text-xs font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
            keyboardOpen ? 'border-primary bg-primary/[0.06] text-foreground' : 'border-border/60 bg-surface text-foreground hover:border-brand/40 hover:text-brand',
          )}
        >
          <Keyboard className="size-3.5" strokeWidth={1.5} />
          {copy.keyboard}
        </button>
      }
    >
      <button
        type="button"
        onClick={onToggleKeyboard}
        data-testid="label-images-character"
        aria-label={value ? fillCopy(copy.slotLabel, { value }) : copy.slotEmpty}
        className={cn(
          'flex h-24 w-full items-center justify-center rounded-lg border-2 border-dashed font-mono transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
          value ? 'border-primary/40 bg-primary/[0.04] text-4xl font-semibold text-foreground' : 'border-border/60 bg-surface-2 text-sm text-muted-foreground hover:border-brand/40',
        )}
      >
        {value || copy.slotEmpty}
      </button>
    </TaskItemCard>
  );
}
